import { useEffect, useRef, useState } from 'react';

/**
 * The state of a form that starts from the settings of the server (one part of the answer of GET /api/ai/settings/audio).
 *
 * The screens of all the parts (Google, Inworld, the rules) stay mounted at the same time and share one answer of the server.
 * After a save of one part the whole answer is replaced, so a form must not start again just because the answer is a new object:
 * the changes that were not saved in the other tabs would be lost. The form starts again only when
 *  - the content of its own part changed (after its own save), or
 *  - the settings were loaded again on purpose (loadCount grows - the "טעינה מחדש מהשרת" button, or the first load).
 *
 * @param {object|null} part      the part of the answer that the form is made from (null - not loaded yet)
 * @param {(part: object) => object} toForm   makes the form from the part - a function that does not change between renders
 * @param {number} loadCount      the number of the loads of the settings (store.loadCount)
 * @returns {[object|null, Function]} the form (null until the part is loaded) and its setter
 */
export default function useServerForm(part, toForm, loadCount) {
    const [form, setForm] = useState(null);
    const partRef = useRef(part);
    partRef.current = part;
    const contentKey = part ? JSON.stringify(part) : '';

    useEffect(() => {
        if (partRef.current) setForm(toForm(partRef.current));
    }, [contentKey, loadCount, toForm]);

    return [form, setForm];
}
